// extracted by mini-css-extract-plugin
export default {"multiTitle":"DeviceShortInfo_multiTitle__tqBKF","deviceProductGroup":"DeviceShortInfo_deviceProductGroup__IeIs3","deviceType":"DeviceShortInfo_deviceType__Wtbs1"};